import { GDPR_SETTINGS } from 'constants/commons';

const APP_LOCALE = 'appLocale';

export const getAppLocale = (): string | null =>
  localStorage.getItem(APP_LOCALE);

export const saveAppLocale = (locale: string): void =>
  localStorage.setItem(APP_LOCALE, locale);

export const getGDPRSettings = (): any =>
  JSON.parse(localStorage.getItem(GDPR_SETTINGS) as string);

export const saveGDPRSettings = (settings: any): void =>
  localStorage.setItem(GDPR_SETTINGS, JSON.stringify(settings));
